import React from "react"
import { ColorPickerSeeker } from "@ui-seeker/core"

import { useUserSettingsProvider, useUserSettingsProviderValidator } from "../../../@hooks"
import { userSettingProvidersFormData } from "../../../@signals"


export default function UserSettingProviderDrawerColor() {
	const { handleChangeProviderFormData } = useUserSettingsProvider()
	const { colorError } = useUserSettingsProviderValidator()

    return <ColorPickerSeeker
		value={userSettingProvidersFormData.value?.color}
		onChange={newColor => handleChangeProviderFormData(newColor, 'color')}
		label="Color"
		error={colorError}
	/>
}